import type { ReactNode } from 'react';
import { Button } from '@vd/ui';
import styles from './WidgetNudge.module.css';

/**
 * "Want bug reports from these sites without the extension?", with a way into
 * the widget's setup. On the project's URL patterns and on How capture works
 * (TOADO-600), each saying in its own words how the widget relates to that page.
 */
export function WidgetNudge({ children, onSetupWidget }: {
  /** The sentence under the question, about the page it is on. */
  children: ReactNode;
  onSetupWidget: () => void;
}) {
  return (
    <div className={styles.nudge} data-testid="widget-nudge">
      <div>
        <strong>Want bug reports from these sites without the extension?</strong>
        <p className={styles.body}>{children}</p>
      </div>
      <Button variant="secondary" onClick={onSetupWidget}>Set up the widget</Button>
    </div>
  );
}
